'use client'

import { useEffect, useState } from 'react'
import type { SellerFeatures } from '@/lib/seller/getSellerFeatures'

export function useSellerFeatures(
  sellerId?: number | null
) {
  const [features, setFeatures] =
    useState<SellerFeatures | null>(null)

  const [loading, setLoading] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    let cancelled = false

    async function run() {
      if (!sellerId) {
        setFeatures(null)
        return
      }

      try {
        setLoading(true)

        const res = await fetch(
          `/api/seller/${sellerId}/features`,
          {
            cache: 'no-store',
          }
        )

        const data = await res.json()

        if (!res.ok || !data?.ok) {
          throw new Error(
            data?.error ||
              'Failed to load seller features'
          )
        }

        if (!cancelled) {
          setFeatures(data.features ?? null)
        }
      } catch {
        if (!cancelled) {
          setFeatures(null)
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    void run()

    return () => {
      cancelled = true
    }
  }, [sellerId, refreshKey])

  function refresh() {
    setRefreshKey((value) => value + 1)
  }

  return {
    features,
    loading,
    refresh,
  }
}